/**
 * Statik default renk paleti.
 *
 * Bu dosya geriye uyumluluk için korunuyor.
 * Yeni bileşenlerde `useClinicTheme()` hook'unu tercih edin.
 *
 *   import { useClinicTheme } from "../theme";
 *   const { palette } = useClinicTheme();
 */
import { generatePalette } from "../theme/themeUtils";
import { DEFAULT_PRIMARY } from "../theme/palettes";

const colors = generatePalette(DEFAULT_PRIMARY);

export default colors;
